export default __webpack_public_path__ + "static/media/js.621f6061.png";